import React from 'react';
import planning from '../../assets/Images/11.jpg'



const Home = () => {
  return (
    <div className="p-6 h-screen overflow-y-auto mt-40" dir="rtl">
        <h2  className="text-2xl font-semibold text-center text-gray-700 mb-12">تعليمات قياس هدر الغذاء وتسجيل البيانات في النظام</h2>

      <p>المهمة المطلوبة بشكل عام هي إدخال البيانات في النظام:</p>
      <ul className="list-disc pl-6">
        <li>افتح النظام الخاص بالموظفين للبدء بقياس هدر الغذاء.</li>
        <li>قم بإدخال البيانات المطلوبة لكل غذاء مهدر، وتشمل:</li>
      </ul>

      <h4 className="text-md font-semibold mt-2">تفاصيل البيانات المطلوبة:</h4>
      <ul className="list-disc pl-6">
        <li><strong>التاريخ</strong></li>
        <li><strong>نوع الوجبة:</strong> (إفطار، غداء، عشاء، سحور، وجبة خفيفة إلخ)</li>
        <li><strong>المصدر:</strong> (المطبخ، صالة الطعام، بوفيه، إلخ)</li>
        <li><strong>نوع الغذاء:</strong> (لحوم، خضروات، خبز، إلخ)</li>
        <li><strong>وصف الغذاء:</strong> (مثال: دجاج مشوي، أرز أبيض، سلطة خضراء)</li>
        <li><strong>الوردية:</strong> (A, B, C)</li>
        <li><strong>صلاحية الأكل:</strong> (صالح، غير صالح)</li>
        <li><strong>وزن الوعاء الفارغ:</strong> يُقاس بالغرام</li>
        <li><strong>الوزن:</strong> يُقاس بالغرام</li>
        <li><strong>السبب:</strong> (فائض، غير صالح للأكل، إعادة تحضير، سوء تخزين إلخ)</li>
      </ul>

      <h3 className="text-lg font-semibold mt-4">الخطوة الأولى: تحديد مواقع جمع النفايات عبر جولة ميدانية</h3>
      <p>هدر الغذاء يمكن أن ينشأ في عدة مواقع، منها:</p>
      <ul className="list-disc pl-6">
        <li>مناطق التحضير (أماكن تقطيع الخضروات، تحضير اللحوم، إلخ).</li>
        <li>محطات غسل الأطباق / الأواني (حيث تُزال بقايا الطعام من الأطباق).</li>
        <li>سلال المهملات في صالات الطعام والمطبخ.</li>
        <li>أماكن مختلفة يحددها رئيس القسم مسبقًا.</li>
      </ul>
      <p>✅ قم بجولة ميدانية لتحديد المواقع التي سيتم دراستها وتوثيقها وتزويدها لرئيس القسم ليضيفها للنظام الخاص به.</p>

      <h3 className="text-lg font-semibold mt-4">الخطوة الثانية: تحديد موقع لفرز ووزن النفايات</h3>
      <p>يجب فصل نفايات الطعام عن النفايات الأخرى قبل الوزن.</p>
      <p><strong>اختر موقعًا مناسبًا للفرز، ويفضل أن يكون:</strong></p>
      <ul className="list-disc pl-6">
        <li>بعيدًا عن مناطق التحضير والتقديم.</li>
        <li>واسعًا بما يكفي لوضع طاولة وأدوات الوزن.</li>
        <li>قريبًا من نقطة التخلص من النفايات لتسهيل النقل.</li>
      </ul>

      <p className="font-semibold">📌 ملاحظات:</p>
      <ul className="list-disc pl-6">
        <li>بالنسبة للطعام المتبرع به، يُفضل وزنه في مكان التخزين (الثلاجة أو الفريزر).</li>
        <li>بقايا الطعام من مناطق التحضير يمكن وزنها مباشرة داخل الحاويات التي وُضعت فيها.</li>
      </ul>


      <h3 className="text-lg font-semibold mt-4">أدوات قياس هدر الغذاء</h3>
      <ul className="list-disc pl-6">
        <li>ميزان كبير لقياس النفايات الثقيلة.</li>
        <li>ميزان طعام رقمي لقياس الأوزان الدقيقة.</li>
        <li>قفازات (Gloves) لحماية اليدين أثناء الفرز.</li>
        <li>مشمع بلاستيكي لتغطية طاولة الفرز.</li>
        <li>أكياس نفايات شفافة لفصل أنواع المخلفات.</li>
        <li>أوعية وزن لوضع النفايات قبل وزنها.</li>
        <li>مجارف / ملاقط لنقل الطعام المهدر بأمان.</li>
        <li>كاميرا أو هاتف محمول لتوثيق الملاحظات بالصور.</li>
        <li>جهاز لوحي.</li>
        <li>غطاء للرأس.</li>
      </ul>

      <div className="flex justify-center items-center mt-10 mb-10">
        <img src={planning} alt="تعديل" className="w-[100%] h-80 xl:w-[50%]" />
      </div>

      <h3 className="text-lg font-semibold mt-4">الخطوة الثالثة: تسجيل وزن الأوعية الفارغة</h3>
      <p>قبل البدء في الوزن، قم بقياس وزن كل دلو أو وعاء فارغ.</p>
      <p>استخدم هذا الوزن لاحقًا لطرح وزن الأوعية من الوزن الكلي للنفايات، ومن الأفضل تصفير الميزان بعد وضع الوعاء الفارغ على الميزان.</p>

      <h3 className="text-lg font-semibold mt-4">الخطوة الرابعة: إجراء جولات ميدانية دورية</h3>
      <p>قم بجولات قبل وبعد أوقات الوجبات لرصد أماكن تواجد الغذاء المهدر.</p>
      <p>راقب مستوى امتلاء سلال المهملات وما تحتويه.</p>

      <h3 className="text-lg font-semibold mt-4">الخطوة الخامسة: فصل الغذاء عن النفايات غير الغذائية وتسجيله</h3>
      
      <p className="font-semibold">📌 التصنيف الأساسي لهدر الطعام:</p>
      <ul className="list-disc pl-6">
        <li><strong>ما قبل الاستهلاك:</strong> مخلفات التحضير (قصاصات الخضار، بقايا الطهي، طعام غير مُستخدم).</li>
        <li><strong>ما بعد الاستهلاك:</strong> (بقايا الأكل من الأطباق).</li>
      </ul>

      <p className="font-semibold">📌 الفرز والتسجيل:</p>
      <ul className="list-disc pl-6">
        <li>يجب قياس بقايا الطعام والطعام الفائض بشكل منفصل.</li>
        <li>✅ التقاط الصور والملاحظات أثناء الفرز لتوثيق فرص التحسين.</li>
      </ul>

      <h3 className="text-lg font-semibold mt-4">📌 طرق الفرز والفصل</h3>

      <h4 className="text-md font-semibold mt-2">🔹 الطريقة 1 - دلو النفايات</h4>
      <p>استخدم أدوات يدوية (مجارف، ملاقط) أو قفازات لنقل الطعام المهدر إلى دلو الوزن.</p>
      <p>ضع النفايات غير الغذائية (بلاستيك، ورق، إلخ) في سلة منفصلة.</p>
      <p><strong>ملاحظة:</strong> احترس من الأدوات الحادة أو المخاطر البيولوجية داخل النفايات.</p>

      <p className="font-semibold mb-40">✅ باتباع هذه التعليمات، يمكن تحسين عملية قياس هدر الغذاء وتحقيق استدامة أفضل في المنشأة.</p>

    </div>
  );
};

export default Home;
